import React, { useEffect } from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { useFormikContext } from 'formik';
import type { BusinessOwnerType } from 'global-intern-types';
import businessOwnerTypes from '../constants/businessOwnerTypes';
import { AgentInputType } from '../../../types/AgentInputType.types';
import Agentv2 from '../../../types/Agentv2.types';

const LABELS: Record<BusinessOwnerType, string> = { MAN: 'Mann', WOMAN: 'Frau', COMPANY: 'Firma' };

export default function BusinessOwnerTypeField() {
  const { values, errors, handleBlur, setFieldValue } = useFormikContext<AgentInputType | Agentv2>();
  const hasOwner = Boolean(values.business_owner?.trim());
  useEffect(() => {
    if (!hasOwner && values.business_owner_type != null) {
      setFieldValue('business_owner_type', null);
    }
  }, [hasOwner, values.business_owner_type, setFieldValue]);

  return (
    <FormControl
      fullWidth
      disabled={!hasOwner}
      required={hasOwner}
      error={hasOwner && Boolean(errors.business_owner_type)}
    >
      <InputLabel id="business-owner-type-label">Vertragsinhaber ist</InputLabel>
      <Select
        labelId="business-owner-type-label"
        id="business-owner-type"
        name="business_owner_type"
        label="Vertragsinhaber ist"
        value={hasOwner ? (values.business_owner_type ?? '') : ''}
        onChange={(event) => setFieldValue('business_owner_type', event.target.value)}
        onBlur={handleBlur}
        inputProps={{ 'aria-describedby': 'business-owner-type-error' }}
      >
        {businessOwnerTypes.map((type) => (
          <MenuItem key={type} value={type}>
            {LABELS[type]}
          </MenuItem>
        ))}
      </Select>
      {hasOwner && errors.business_owner_type && (
        <FormHelperText id="business-owner-type-error">{errors.business_owner_type}</FormHelperText>
      )}
    </FormControl>
  );
}
